function isHttpOrigin(origin) {
  return /^https?:\/\//.test(origin || '');
}

export async function registerServiceWorker(options = {}) {
  const env = options.env || process.env.NODE_ENV;
  const origin = options.origin || window.location.origin;
  const force = Boolean(options.force);
  const serviceWorker = options.serviceWorker || window.navigator.serviceWorker;

  if (!serviceWorker || typeof serviceWorker.register !== 'function') {
    return { status: 'unsupported' };
  }

  if (env !== 'production' && !force) {
    return { status: 'skipped' };
  }

  if (!isHttpOrigin(origin)) {
    return { status: 'invalid-origin' };
  }

  try {
    if (typeof serviceWorker.getRegistrations !== 'function') {
      return { status: 'disabled' };
    }
    const registrations = await serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));
    return { status: 'unregistered', count: registrations.length };
  } catch (error) {
    return { status: 'failed', error };
  }
}
